module.exports = __webpack_public_path__ + "img/billable-rate-circle.c65b7630.svg";